import axios from "axios";
export default {
    state: {
        selectedPoints: [],
        customPoints: [],
        ashi: "",
        classicGroups: [],
        customGroups: [],
        loading: false,
        searchedPoints: [],
        TOP_CHANNELS: ["lu", "li", "sj", "he", "pc", "si", "11", "22", "33", "44", "99", "1010", "dt", "vt"],
		BOTTOM_CHANNELS: ["sp", "st", "liv", "gb", "bl", "kd", "55", "66", "77", "88"],
		CENTRAL_CHANNELS: ["ren", "du", "ex-central"],
        EXTRA_CHANNELS: ["ex"],
        technics: [
			{id: 1, name: "Acupuntura", icon: '$vuetify.icons.acuIcon', acu: true, auricular: true},
			{id: 2, name: "Moxa", icon: '$vuetify.icons.acuTechnic4', acu: true, auricular: true},
			{id: 3, name: "Sangria", icon: '$vuetify.icons.acuTechnic1', acu: true, auricular: true},
			{id: 4, name: "Ventosa", icon: '$vuetify.icons.acuTechnic3', acu: true, auricular: false},
			{id: 5, name: "Electro", icon: '$vuetify.icons.acuTechnic2', acu: true, auricular: true},
			{id: 6, name: "Esfera Magnética", icon: 'mdi-circle-slice-8', acu: false, auricular: true},
			{id: 7, name: "Semente", icon: 'mdi-circle-medium', acu: false, auricular: true},
            {id: 8, name: "ASP", icon: 'mdi-arrow-down-bold', acu: false, auricular: true},
            {id: 9, name: "TDP", icon: 'mdi-white-balance-sunny', acu: true, auricular: false}
		]
    },
    getters: {
        acuPoints: (state) => (auricular) => {
            return state.selectedPoints.filter(p => p.auricular == auricular);
        },
        acuTechnics: state => (auricular) => {
            if(auricular) return state.technics.filter(t => t.auricular);
            else return state.technics.filter(t => t.acu);
        },
        acuSearchedPoints: (state) => {
            return state.searchedPoints;
        },
        acuCustomPoints: state => (auricular) => {
            return state.customPoints.filter(p => p.auricular == auricular);
        },
        ashiPoints: state => {
            return state.ashi;
        },
        acuLoading: state => {
            return state.loading;
        },
        acuClassicGroups: state => (auricular) => {
            return state.classicGroups.filter(g => g.auricular == auricular);
        },
        acuCustomGroups: state => (auricular) => {
            return state.customGroups.filter(g => g.auricular == auricular);
        },
        acuPointQuadrant: state => (point) => {
            var channel = point.id.split("-")[0];
            var laterality = point.side;
            if (point.quadrant) return point.quadrant;
            if (point.auricular) {
                if(laterality == 'right') return 1
                else return 2
            }
			if (point.id == 'ex-hn-54R' || point.id == 'ex-hn-30R' || point.id == 'ex-hn-14R' || point.id == 'ex-hn-10R' || point.id == 'ex-hn-18R' || point.id == 'ex-hn-21R' || point.id == 'ex-hn-8R' || point.id == 'ex-hn-9R' ||
					point.id == 'ex-hn-32R' || point.id == 'ex-hn-6R' || point.id == 'ex-bw-1R' || point.id == 'ex-bw-35R' || point.id == 'ex-bw-3R' || point.id == 'ex-bw-12R' ||
					point.id == 'ex-ue-22R' || point.id == 'ex-ue-bR' || point.id == 'ex-ue-29R' || point.id == 'ex-ue-dR' || point.id == 'ex-ue-24R' || point.id == 'ex-ue-1R' ||
					point.id == 'ex-ue-9R' || point.id == 'ex-ue-19R' || point.id == 'ex-ue-eR' || point.id == 'ex-ue-fR' || point.id == 'ex-ue-46R') return 1;
			if (point.id == 'ex-hn-54L' || point.id == 'ex-hn-30L' || point.id == 'ex-hn-14L' || point.id == 'ex-hn-10L' || point.id == 'ex-hn-18L' || point.id == 'ex-hn-21L' || point.id == 'ex-hn-8L' || point.id == 'ex-hn-9L' ||
					point.id == 'ex-hn-32L' || point.id == 'ex-hn-6L' || point.id == 'ex-bw-1L' || point.id == 'ex-bw-35L' || point.id == 'ex-bw-3L' || point.id == 'ex-bw-12L' ||
					point.id == 'ex-ue-22L' || point.id == 'ex-ue-bL' || point.id == 'ex-ue-29L' || point.id == 'ex-ue-dL' || point.id == 'ex-ue-24L' || point.id == 'ex-ue-1L' ||
					point.id == 'ex-ue-9L' || point.id == 'ex-ue-19L' || point.id == 'ex-ue-eL' || point.id == 'ex-ue-fL' || point.id == 'ex-ue-46L') return 2;
			if (point.id == 'ex-hn-1C' || point.id == 'ex-hn-3C' || point.id == 'ex-hn-20C')
                return 5;
            if (point.id == 'ex-bw-25C' || point.id == 'ex-ca-23C')
				return 6;
			if (state.TOP_CHANNELS.includes(channel) && laterality == "right") return 1;
            if (state.TOP_CHANNELS.includes(channel) && laterality == "left") return 2;
            if (state.TOP_CHANNELS.includes(channel) && laterality == "center") return 5;
			if ((state.BOTTOM_CHANNELS.includes(channel) && laterality != "left") || (state.EXTRA_CHANNELS.includes(channel) && laterality != "left"))
				return 3;
			if ((state.BOTTOM_CHANNELS.includes(channel) && laterality != "right") || (state.EXTRA_CHANNELS.includes(channel) && laterality != "right"))
				return 4;
			if (state.CENTRAL_CHANNELS.includes(channel)) {
                var number = point.id.split("-")[1];
                number = number.slice(0, -1);
                if(channel == 'ren') {
                    if(number > 8) return 5;
                    else return 6;
                } else if(channel == 'du') {
                    if(number > 4) return 5;
                    else return 6;
                } else return 5;
            }
        }
    },
    mutations: {
        RESET_DATA(state) {
            state.classicGroups = [];
            state.customGroups = [];
            state.customPoints = [];
            state.selectedPoints = [];
            state.searchedPoints = [];
        },
        SET_DATA(state, data) {
            state.classicGroups = data.classic_groups;
            state.customGroups = data.custom_groups;
            state.customPoints = data.custom_points;
        },
        SET_POINTS(state, points) {
            state.selectedPoints = points;
        },
        SET_SEARCH_POINTS(state, points) {
            state.searchedPoints = points;
        },
        ADD_POINTS(state, points) {
            points.forEach(p => {
                let index = state.selectedPoints.findIndex(point => point.id == p.id);
                if(index == -1) state.selectedPoints.unshift(p);
            });
        },
        REMOVE_POINT(state, id) {
            let index = state.selectedPoints.findIndex(p => p.id == id);
            state.selectedPoints.splice(index, 1);
        },
        REMOVE_POINTS(state, points) {
            for(let i = 0; i < points.length; i++) {
                let index = state.selectedPoints.findIndex(p => p.id == points[i].id);
                state.selectedPoints.splice(index, 1);
            }
        },
        REMOVE_ALL_POINTS(state, auricular) {
            state.selectedPoints = state.selectedPoints.filter(p => p.auricular != auricular);
        },
        SET_ASHI(state, ashi) {
            state.ashi = ashi;
        },
        SET_ACU_LOADING(state, value) {
            state.loading = value;
        },
        ADD_GROUP(state, group) {
            if(group.user_id) state.customGroups.push(group);
            else state.classicGroups.push(group);
        },
        ADD_CLASSIC_GROUP(state, group) {
            state.classicGroups.push(group);
        },
        EDIT_GROUP(state, group) {
            let currentGroup;
            if(group.user_id) currentGroup = state.customGroups.find(g => g.id === group.id);
            else currentGroup = state.classicGroups.find(g => g.id === group.id);
            Object.assign(currentGroup, group);
        },
        REMOVE_GROUP(state, group) {
            let index;
            if(group.user_id) {
                index = state.customGroups.findIndex(g => g.id == group.id);
                state.customGroups.splice(index, 1);
            } else {
                index = state.classicGroups.findIndex(g => g.id == group.id);
                state.classicGroups.splice(index, 1);
            }
        },
        ADD_POINT(state, points) {
            for(let i = 0; i < points.length; i++) {
                if(points[i].user_id) state.customPoints.push(points[i]);
            }
        },
        EDIT_POINT(state, point) {
            if(point.user_id) {
                let currentPoint = state.customPoints.find(p => p.id === point.id);
                Object.assign(currentPoint, point);
            }
        },
        REMOVE_CUSTOM_POINT(state, id) {
            let index = state.customPoints.findIndex(p => p.id == id);
            state.customPoints.splice(index, 1);
        },
        SET_CUSTOM_GROUPS(state, groups) {
            state.customGroups = groups;
        },
        EDIT_SELECTED_POINT(state, point) {
            let currentPoint = state.selectedPoints.find(p => p.id === point.id);
            Object.assign(currentPoint, point);
        }
    },
    actions: {
        RESET_DATA: ({ commit }) => {
            commit('RESET_DATA');
        },
        GET_DATA: ({ commit }) => {
            commit('SET_ACU_LOADING', true);
            return new Promise((resolve, reject) => {
                axios
                .get("/acupuncture")
                    .then(response => {
                        console.log(response.data);
                        commit('SET_DATA', response.data);
                        commit('SET_ACU_LOADING', false);
                        resolve(response.data.custom_points);
                    })
                    .catch(error => {
                        console.log(error);
                        commit('SET_ACU_LOADING', false);
                        reject();
                    });
            });
        },
        GET_ACU_POINTS: ({ commit }, payload) => {
            commit('SET_ACU_LOADING', true);
            return new Promise((resolve, reject) => {
                axios
                .post("/acupuncture/appointment/" + payload.appointment, payload)
                .then(response => {
                    console.log(response.data);
                    commit('SET_POINTS', response.data.points);
                    commit('SET_ACU_LOADING', false);
                    resolve();
                })
                .catch(error => {
                    console.log(error);
                    commit('SET_ACU_LOADING', false);
                    reject();
                });
            });
        },
        SAVE_ACU_POINTS: ({ commit }, payload) => {
            commit('SET_ACU_LOADING', true);
            return new Promise((resolve, reject) => {
                axios
                .post("/acupuncture/appointment/" + payload.appointment, payload)
                .then(response => {
                    console.log(response.data);
                    commit('SET_ACU_LOADING', false);
                    resolve();
                })
                .catch(error => {
                    console.log(error);
                    commit('SET_ACU_LOADING', false);
                    reject();
                });
            });
        },
        SET_ACU_POINTS: ({ commit }, payload) => {
            commit('SET_POINTS', payload.points);
            commit('SET_ASHI', payload.ashi_points);
        },
        ADD_POINTS: ({ commit }, payload) => {
            commit('SET_ACU_LOADING', true);
            return new Promise((resolve, reject) => {
                axios
                .post("/acupuncture/appointment/" + payload.appointment, payload)
                .then(response => {
                    console.log(response.data);
                    commit('ADD_POINTS', response.data.points);
                    commit('SET_ACU_LOADING', false);
                    resolve(response.data.points);
                })
                .catch(error => {
                    console.log(error);
                    commit('SET_ACU_LOADING', false);
                    reject();
                });
            });
        },
        REMOVE_POINT: ({ commit }, payload) => {
            commit('SET_ACU_LOADING', true);
            return new Promise((resolve, reject) => {
                axios
                .post("/acupuncture/appointment/" + payload.appointment, payload)
                .then(response => {
                    console.log(response.data);
                    if(response.data.result == "deleted") {
                        commit('REMOVE_POINT', payload.id);
                        resolve();
                    }
                    commit('SET_ACU_LOADING', false);
                })
                .catch(error => {
                    console.log(error);
                    reject();
                    commit('SET_ACU_LOADING', false);
                });
            });
        },
        REMOVE_ALL_POINTS: ({ commit }, payload) => {
            return new Promise((resolve, reject) => {
                axios
                .post("/acupuncture/appointment/" + payload.appointment, payload)
                .then(response => {
                    console.log(response.data);
                    commit('REMOVE_ALL_POINTS', payload.auricular);
                    resolve();
                })
                .catch(error => {
                    console.log(error);
                    reject();
                });
            });
        },
        SAVE_ASHI: ({ commit }, payload) => {
            if(payload.appointment == -1) {
                commit('SET_ASHI', payload.ashi_points);
                return 0;
            }
            commit('SET_ACU_LOADING', true);
            axios
                .post("/acupuncture/appointment/" + payload.appointment, payload)
                    .then(response => {
                        console.log(response.data);
                        commit('SET_ASHI', response.data);
                        commit('SET_ACU_LOADING', false);
                    })
                    .catch(error => {
                        console.log(error);
                        commit('SET_ACU_LOADING', false);
                    });
        },
        GET_VISIBLE_POINTS: ({ commit }, payload) => {
            commit('SET_ACU_LOADING', true);
            return new Promise((resolve, reject) => {
                axios
                .post("/acupuncture/points", payload)
                .then(response => {
                    commit('SET_ACU_LOADING', false);
                    console.log(response.data);
                    resolve(response.data);
                })
                .catch(error => {
                    console.log(error);
                    commit('SET_ACU_LOADING', false);
                    reject();
                });
            });
        },
        GET_CUSTOM_GROUPS: ({ commit }) => {
            commit('SET_ACU_LOADING', true);
            return new Promise((resolve, reject) => {
                axios
                .get("/acupuncture/custom-groups")
                .then(response => {
                    console.log(response.data);
                    commit('SET_CUSTOM_GROUPS', response.data.groups);
                    commit('SET_ACU_LOADING', false);
                    resolve(response.data);
                })
                .catch(error => {
                    console.log(error);
                    commit('SET_ACU_LOADING', false);
                    reject();
                });
            });
        },
        APLY_CUSTOM_GROUP: ({ commit }, payload) => {
            commit('SET_ACU_LOADING', true);
            return new Promise((resolve, reject) => {
                axios
                .post("/acupuncture/appointment/" + payload.appointment, payload)
                .then(response => {
                    console.log(response.data);
                    commit('ADD_POINTS', response.data.points);
                    if(response.data.ashi_points) commit('SET_ASHI', response.data.ashi_points);
                    commit('SET_ACU_LOADING', false);
                    resolve(response.data.points);
                })
                .catch(error => {
                    console.log(error);
                    commit('SET_ACU_LOADING', false);
                    reject();
                });
            });
        },
        REMOVE_CUSTOM_GROUP: ({ commit }, payload) => {
            commit('SET_ACU_LOADING', true);
            return new Promise((resolve, reject) => {
                axios
                .post("/acupuncture/appointment/" + payload.appointment, payload)
                .then(response => {
                    console.log(response.data);
                    commit('REMOVE_POINTS', response.data.points);
                    commit('SET_ACU_LOADING', false);
                    resolve(response.data.points);
                })
                .catch(error => {
                    console.log(error);
                    commit('SET_ACU_LOADING', false);
                    reject();
                });
            });
        },
        EDIT_POINT_TECHNICS: ({ commit }, payload) => {
            commit('SET_ACU_LOADING', true);
            return new Promise((resolve, reject) => {
                axios
                .post("/acupuncture/appointment/" + payload.appointment, payload)
                .then(response => {
                    console.log(response.data);
                    commit('EDIT_SELECTED_POINT', response.data.point);
                    commit('SET_ACU_LOADING', false);
                    resolve();
                })
                .catch(error => {
                    console.log(error);
                    commit('SET_ACU_LOADING', false);
                    reject();
                });
            });
        },
        CREATE_GROUP: ({ commit }, payload) => {
            commit('SET_ACU_LOADING', true);
            return new Promise((resolve, reject) => {
                axios
                .post("/acupuncture/groups/new", payload)
                .then(response => {
                    commit('SET_ACU_LOADING', false);
                    console.log(response.data);
                    if(response.data.result == "ok") {
                        commit('ADD_GROUP', response.data.group);
                        resolve();
                    } else {
                        reject();
                    }
                })
                .catch(error => {
                    console.log(error);
                    commit('SET_ACU_LOADING', false);
                    reject();
                });
            });
        },
        EDIT_GROUP: ({ commit }, payload) => {
            commit('SET_ACU_LOADING', true);
            return new Promise((resolve, reject) => {
                axios
                .post("/acupuncture/groups/" + payload.id + "/edit", payload)
                .then(response => {
                    console.log(response.data);
                    if(!payload.form) commit('EDIT_GROUP', response.data.group);
                    commit('SET_ACU_LOADING', false);
                    resolve();
                })
                .catch(error => {
                    console.log(error);
                    commit('SET_ACU_LOADING', false);
                    reject();
                });
            });
        },
        DELETE_GROUP: ({ commit }, group) => {
            commit('SET_ACU_LOADING', true);
            return new Promise((resolve, reject) => {
                axios
                .post("/acupuncture/groups/" + group.id + "/delete")
                .then(response => {
                    console.log(response.data);
                    commit('REMOVE_GROUP', group);
                    commit('SET_ACU_LOADING', false);
                    resolve();
                })
                .catch(error => {
                    console.log(error);
                    commit('SET_ACU_LOADING', false);
                    reject();
                });
            });
        },
        CREATE_POINT: ({ commit }, payload) => {
            commit('SET_ACU_LOADING', true);
            return new Promise((resolve, reject) => {
                axios
                .post("/acupuncture/points/new", payload)
                .then(response => {
                    commit('SET_ACU_LOADING', false);
                    console.log(response.data);
                    if(response.data.result == "ok") {
                        commit('ADD_POINT', response.data.points);
                        if(response.data.group) commit('ADD_CLASSIC_GROUP', response.data.group);
                        resolve(response.data.points);
                    } else {
                        reject();
                    }
                })
                .catch(error => {
                    console.log(error);
                    commit('SET_ACU_LOADING', false);
                    reject();
                });
            });
        },
        EDIT_POINT: ({ commit }, payload) => {
            commit('SET_ACU_LOADING', true);
            return new Promise((resolve, reject) => {
                axios
                .post("/acupuncture/points/" + payload.id + "/edit", payload)
                .then(response => {
                    console.log(response.data);
                    if(!payload.form) commit('EDIT_POINT', response.data.point);
                    commit('SET_ACU_LOADING', false);
                    resolve();
                })
                .catch(error => {
                    console.log(error);
                    commit('SET_ACU_LOADING', false);
                    reject();
                });
            });
        },
        DELETE_POINT: ({ commit }, point) => {
            commit('SET_ACU_LOADING', true);
            return new Promise((resolve, reject) => {
                axios
                .post("/acupuncture/points/" + point.id + "/delete")
                .then(response => {
                    commit('SET_ACU_LOADING', false);
                    console.log(response.data);
                    commit('REMOVE_CUSTOM_POINT', point.id);
                    resolve();
                })
                .catch(error => {
                    console.log(error);
                    commit('SET_ACU_LOADING', false);
                    reject();
                });
            });
        },
        GET_POINT_INFO: (_, payload) => {
            return new Promise((resolve, reject) => {
                axios
                .get("/acupuncture/points/" + payload.id, { params: { form: payload.form } })
                .then(response => {
                    console.log(response.data);
                    resolve(response.data.point);
                })
                .catch(error => {
                    console.log(error);
                    reject();
                });
            });
        },
        GET_GROUP_INFO: (_, payload) => {
            return new Promise((resolve, reject) => {
                axios
                .get("/acupuncture/groups/" + payload.id, { params: { form: payload.form } })
                .then(response => {
                    console.log(response.data);
                    resolve(response.data.group);
                })
                .catch(error => {
                    console.log(error);
                    reject();
                });
            });
        },
        SEARCH_POINTS: ({ commit }, payload) => {
            commit('SET_ACU_LOADING', true);
            return new Promise((resolve, reject) => {
                axios
                .get("/acupuncture/search", {params: payload})
                .then(response => {
                    console.log(response.data);
                    commit('SET_SEARCH_POINTS', response.data.points);
                    commit('SET_ACU_LOADING', false);
                    resolve(response.data.group);
                })
                .catch(error => {
                    console.log(error);
                    commit('SET_ACU_LOADING', false);
                    reject();
                });
            });
        }
    }
}